// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import Vant from 'vant'
import { Toast, Dialog } from 'vant'
import axios from 'axios'
import MD5 from 'md5.js'
import FastClick from 'fastclick'
import clipboard from 'clipboard'
import 'lib-flexible/flexible'
import wx from 'weixin-js-sdk'

import 'vant/lib/index.css'
import 'swiper/dist/css/swiper.css'
import './assets/css/app.css'
import './assets/css/font_3784785_ckp6v4e69nk.css'
import './assets/css/ysq.css'
import * as Util from './assets/js/util'
import * as device from './assets/js/device'
import * as lang from './assets/js/lang'

import App from './App'
axios.defaults.baseURL = getApiHost()
// axios.defaults.timeout = 30000;

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

localStorage.removeItem('appInit');
Vue.prototype.$baidumap_ak='AYrmv0jo7khwCtiB4YmxAU0HbEVWsu2n';//秘钥
Vue.prototype.$http = axios;
Vue.prototype.Util = Util
Vue.prototype.device = device
Vue.prototype.lang = lang
Vue.prototype.modle_dev = true
Vue.config.ignoredElements = ['wx-open-launch-weapp']

Vue.config.productionTip = false
Vue.use(Vant, axios, Toast)

if (!Util.isCurrentUser()) {
  if(window.location.pathname != '/receive'){
    wechatAuth()
  }
}

//路由拦截
axios.interceptors.request.use(
    (res)=>{
      console.log('axios request',res)

      var city=localStorage.getItem('location_city')
      if(res.url.indexOf('?')==-1){
        res.url+=('?city='+city)
      }else{
        res.url+=('&city='+city)
      }


      return res;
    }
);
axios.interceptors.response.use(
    (res) => {
      console.log('route', router.history.current.path)
      if (res.data.code == 401) {
        wechatAuth()
      } else {
        return res;
      }
    }
);

// let objUserInfo = JSON.parse(localStorage.userInfo)

// var ws = new WebSocket("ws://120.55.125.146:1234");
// var uid = objUserInfo.id;
// var heartbeat = null;
//连接心跳
// ws.onopen = function () {
//   console.log('连接成功');
//   var param = {
//     type: 'open',
//     uid: uid
//   }
//   ws.send(JSON.stringify(param))

//   heartbeat = setInterval(() => {
//     var param = {
//       type: 'heartbeat',
//       uid: uid
//     }
//     ws.send(JSON.stringify(param))
//   }, 3000)
// };

// ws.onclose = function (e) {
//   clearInterval(heartbeat);
//   console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
// };

//FastClick的ios点击穿透解决方案
FastClick.prototype.focus = function (targetElement) {
  let length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus(); //增加这一行代码！！！
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    FastClick.attach(document.body)
  }, false);
}
localStorage.lang = 'zh-cn'
localStorage.langId = 0

router.beforeEach(function (to, from, next) {
  if(localStorage.userInfo){
    // console.log("to", to, JSON.parse(window.localStorage.getItem('userInfo')).id)
    // if(JSON.parse(window.localStorage.getItem('userInfo')).id == 5271 || JSON.parse(window.localStorage.getItem('userInfo')).id == 4404) {
    //   console.log("first", to)
    //   const toStr = JSON.stringify(to.name)
    //   window.alert(toStr)
    // }
    wxJsSdk(to)
  }
  if (to.fullPath == '/') {
    next({
      name: "home"
    });
  } else if (to.name == 'page') {
    //toastText('升级中...')
    //return;
  } else if (to.meta.requireAuth) {
    console.log(111);
    if (Util.isCurrentUser()) {
      next();
    } else {
      console.log(222);
      wechatAuth()
    }
  } else {
    next();
  }
});

function wechatAuth() {
  console.log('跳转微信登录')
  var dev=false
  //正式
  const _wechatAuth = process.env.NODE_ENV === "development" ||dev ?'https://api.yishangquanxm.com/api/wechat/auth':'https://api.yishangquanxm.com/api/wechat/auth'
  //测试
  console.log('window.location', window.location);
  if(window.location.search!=''){
    window.location.replace(_wechatAuth+window.location.search+'&url='+window.location.origin+window.location.pathname);
  }else{
    window.location.replace(_wechatAuth+'?url='+window.location.origin+window.location.pathname);
  }
  if(process.env.NODE_ENV === "development"||dev ){
    var t = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ4eXkuYXBpIiwiYXVkIjoieHl5LmFwaSIsImlhdCI6MTc2NzY4MzY4MiwibmJmIjoxNzY3NjgzNjgyLCJleHAiOjE3Njc4NTY0ODIsImV4dGVuZCI6eyJpZCI6ImFwaTUyNzEiLCJ0eXBlIjoiYXBpIiwidXNlcl9pZCI6NTI3MX19.JEDEPwi3Mj2CNtMA5p-cc6lvZ027LXqt6TZk0ZTenMg';
    localStorage.setItem('token', 'Bearer ' + t);
  }
}
//
let pathname = window.location.pathname;
let time = new Date().getTime();
router.afterEach(function (to) {
  document.title = '装修信用平台'
  let bodySrcollTop = document.body.scrollTop
  if (bodySrcollTop !== 0) {
    document.body.scrollTop = 0
    return
  }
  let docSrcollTop = document.documentElement.scrollTop
  if (docSrcollTop !== 0) {
    document.documentElement.scrollTop = 0
  }
  sessionStorage.to = to
  sessionStorage.name = to.name
  console.log('在' + pathname + '停留了' + (new Date().getTime() - time)/1000 + "秒")
  time = new Date().getTime();
  pathname = window.location.pathname;
  if(localStorage.userInfo){
    console.log("to", to, JSON.parse(window.localStorage.getItem('userInfo')).id)
    // if(JSON.parse(window.localStorage.getItem('userInfo')).id == 5271 || JSON.parse(window.localStorage.getItem('userInfo')).id == 4404) {
    //   console.log("first", to)
    //   const toStr = JSON.stringify(to.name)
    //   window.alert(toStr)
    // }
    wxJsSdk(to)

  }
});

Vue.prototype.clipboard = clipboard;

function getApiHost() {
  console.log("process.env.NODE_ENV ",process.env.NODE_ENV )
  // return process.env.NODE_ENV === "development" ? 'https://dev.rcglife.com/api/' : 'https://api.yishangquanxm.com/api/';
  return process.env.NODE_ENV === "development" ? 'https://api.yishangquanxm.com/api/' : 'https://api.yishangquanxm.com/api/';
}
Vue.prototype.$getApiHost = function () {
  return getApiHost()
}

Vue.prototype.$getImgBase = function () {
  return 'https://qiniu.yishangquanxm.com/'
}

Vue.prototype.$toastLoad = function (_msg = lang.lang[Util.chooseLang()].load, _time = 0, _mask = true) {
  toastLoad(_msg, _time, _mask)
}
function toastLoad(_msg = lang.lang[Util.chooseLang()].load, _time = 0, _mask = true) {
  Toast.loading({
    duration: _time,
    mask: _mask,
    message: _msg
  });
}
Vue.prototype.$toastText = function (_msg = lang.lang[Util.chooseLang()].error) {
  toastText(_msg)
}
function toastText(_msg = lang.lang[Util.chooseLang()].error) {
  Toast({
    message: _msg,
    position: 'bottom'
  });
}
Vue.prototype.$clearToast = function () {
  Toast.clear();
}
Vue.prototype.$isLoad = function (_key, _type, _msg = lang.lang[Util.chooseLang()].load) {
  if (_type == 1) {
    toastLoad(_msg)
  } else {
    Toast.clear();
    localStorage.setItem(_key, true)
  }
}
Vue.prototype.$go = function (_name = '', params = {}, _type = 0) {
  // const _item = JSON.parse()
  if(_name.length<1){
    this.$toastText("抱歉!此功能暂未开放。")
    return;
  }
  setItem('decorationco', 0);
  if ((_name == "designer-detail" || _name == "store-detail") && sessionStorage.name == 'decorationco-detail') {
    setItem('decorationco', document.documentElement.scrollTop);
  }
  console.log('$go',_name,params)
  if (_type == 0) {
    router.push({
      name: _name,
      params: params
    }).catch(err => { console.log(err) });

  } else if (_type == 1) {
    router.replace({
      name: _name,
      params: params
    }).catch(err => { console.log(err) })
  }
}


Vue.prototype.$home_swiperOption= function (){
  return {
    name: 'topSwiper',
    slidesPerView: 'auto',
    spaceBetween: 8,
    touchMoveStopPropagation:false,
    pagination: {
      el: ".case-banner .banner-page",
      type: "fraction",
    }
    // loop: true,
    // autoplay:true
    // freeMode: true,
    // mousewheel: true
  }
}
Vue.prototype.$setItem = function (key, newVal) {
  setItem(key, newVal)
}
function setItem(key, newVal) {
  var newStorageEvent = document.createEvent('StorageEvent');
  const storage = {
    setItem: function (k, val) {
      localStorage.setItem(k, val);
      newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
      window.dispatchEvent(newStorageEvent)
    }
  }
  return storage.setItem(key, newVal);
}
Vue.prototype.$reloadUserInfo = function (isClear = true) {

  reloadUserInfo(isClear)

}   
Vue.prototype.$getOneStar=function(){
  return 2000
}
Vue.prototype.$getLocalGps=function(){
  getIpLocation()
  return getLongitudeLatitude()
}
Vue.prototype.$isWechat=function(){
  //  document.documentElement.scrollTop = 0
  var ua = window.navigator.userAgent.toLowerCase();
  /* alert(JSON.stringify(ua)) */
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){

    return true;
  } else{

    return false;
  }
}
function reloadUserInfo(isClear = false) {
  //取消该页面自动跳转
  if(window.location.pathname == '/receive'){
    return true
  }
  setHeader()
  const _userinfo = axios.get('user/info')

  axios.all([_userinfo]).then((response) => {

    for (var i = 0; i < response.length; i++) {
      const _json = response[i].data

      if (_json.code == 200) {
        if (i == 0) {

          setItem('userInfo', JSON.stringify(_json.data))
          setItem('userId', _json.data.id)
        }
      } else {
        // console.log('ccc');
        toastText("正在重新获取数据......")
        dataError(_json)
      }
    }
    if (isClear) {
      Toast.clear();
    }
  }).catch((error) => {
    toastText("正在重新登录...")
  });
}

Vue.prototype.$dataError = function (_json) {
  //Toast.clear()
  dataError(_json)
}
function dataError(_json) {
  if (_json.code == 999) {
    console.log('跳转微信登录')
    wechatAuth()
  } else {
    // console.log('ddd');
    Toast({
      type: 'html',
      message: _json.message,
      duration: 3000,
      position: 'bottom'
    });
  }
}

function setHeader() {
  axios.defaults.headers['Authorization'] = localStorage.token || '';
}
function getIpLocation(){

  axios.get('http://ip-api.com/json/?lang=zh-CN' , {}).then((response) => {
    const _json = response.data
    if (_json.code == 200) {
      const _data = _json.data
      console.log("iplocation",_data)
      // setItem('userId', _json.data.id)
    } else {
      dataError(_json)
    }
  }).catch((error) => {
    //  toastText("分享失败！")
  });
}
function getLongitudeLatitude() {
  //如果该对象存在，那么地理位置服务可用。
  if ('geolocation' in navigator) {
    /* 地理位置服务可用 */
    var options = {
      enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
      timeout: 5000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
      maximumAge: 0 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
    }
    function success(position) {
      //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
      //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
      console.log("position",position)
      var lat = position.coords.latitude //当前位置的纬度
      var lng = position.coords.longitude //当前位置精度
      return  {'lat': lat,'lng': lat }
    }
    function error(err) {
      var errorType = ['您拒绝共享位置信息', '获取不到位置信息', '获取位置信息超时']
      console.log(errorType[err.code - 1])
    }

    navigator.geolocation.getCurrentPosition(success, error, options)
  } else {
    /* 地理位置服务不可用 */
    console.log('无法获取您的位置，请检查定位是否开启或刷新重试')
  }
}
function putShare() {
  const _item = JSON.parse(sessionStorage.to)
  console.log(_item);
  let _params = '';
  if (_item.name == 'store-detail' || _item.name == 'case-detail' || _item.name == 'designer-detail' || _item.name == 'decorationco-detail') {
    _params = {
      'name': _item.name,
      'id': _item.params.id
    }
    const _parseParam = Util.parseParam(_params)
    setHeader()
    axios.get('share?' + _parseParam, {}).then((response) => {
    }).catch((error) => {
      //toastText("分享失败")
    });
  }
}
Vue.prototype.$getYear=function(_time){
  var nd=""+_time
  const today = new Date()
  const workDate = new Date(nd.replace(/-/g,'/'))
  let year = today.getFullYear()-workDate.getFullYear()
  const month = today.getMonth()-workDate.getMonth()
  if(month< 0 ||(month === 0&& today.getDate()< workDate.getDate())){
    year--
  }

  return year
}

function wxJsSdk(_item) {
  let _url = ''
  if (device.deviceType == 'iphone') {
    _url = window.location.origin + '/home'
  } else {
    _url = window.location.href
  }
  let _params = {
    'url': _url,
    'name': _item.name,
    'id': _item.params.id
  }
  const _parseParam = Util.parseParam(_params)

  const _userInfo = JSON.parse(localStorage.userInfo)

  setHeader()
  axios.get('wechat/jssdk?' + _parseParam, {}).then((response) => {
    const _json = response.data
    if (_json.code == 200) {
      console.log("_json", _json)
      const _data = _json.data
      let _title = _data.title,
          _desc = _data.desc,
          _link = window.location.origin + window.location.pathname + '?invite=' + _userInfo['invite_code'],
          // _link = _data.link,
          _img = _data.icon;9
      wx.config({
        debug: false,
        appId: _data.signPackage.appId,
        timestamp: parseInt(_data.signPackage.timestamp),
        nonceStr: _data.signPackage.nonceStr,
        signature: _data.signPackage.signature,
        jsApiList: [
          'wx-open-launch-weapp',
          'checkJsApi',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareQZone'
        ],
        openTagList: ['wx-open-launch-weapp']
      });
      wx.ready(function () {
        wx.onMenuShareTimeline({
          title: _title,
          link: _link,
          imgUrl: _img,
          success: function () {
            Toast({
              message: '分享成功',
              position: 'bottom'
            });
            putShare()
          },
          cancel: function () {
          }
        });
        wx.onMenuShareAppMessage({
          title: _title,
          desc: _desc,
          link: _link,
          imgUrl: _img,
          success: function () {
            // console.log("first", _title, _desc, _link, _img)
            Toast({
              message: '分享成功',
              position: 'bottom'
            });
            putShare()
          },
          cancel: function () {
          }
        });
        wx.onMenuShareQQ({
          title: _title,
          desc: _desc,
          link: _link,
          imgUrl: _img,
          success: function () {
            Toast({
              message: '分享成功',
              position: 'bottom'
            });
            putShare()
          },
          cancel: function () {
          }
        });
        wx.onMenuShareQZone({
          title: _title,
          desc: _desc,
          link: _link,
          imgUrl: _img,
          success: function () {
            Toast({
              message: '分享成功',
              position: 'bottom'
            });
            putShare()
          },
          cancel: function () {
          }
        })
      })
    } else {
      dataError(_json)
    }
  }).catch((error) => {
    //  toastText("分享失败！")
  });
}

function heartbeat() {
  if (localStorage.token) {
    setHeader()
    const _userinfo = axios.get('app/heartbeat')
    axios.all([_userinfo]).then((response) => {
      for (var i = 0; i < response.length; i++) {
        const _json = response[i].data
        if (_json.code == 1) {
          if (i == 0) {
            setTimeout(function () {
              heartbeat()
            }, 60000);
          }
        }
      }
    }).catch((error) => {
    });
  }
}

// import vConsole from '@/assets/js/vconsole.js'

// Vue.prototype.vConsole = vConsole;

// heartbeat()  //心跳检测

Vue.prototype.$setHeader = function () {
  setHeader()
}

window.addEventListener('online', function () {
  Toast.clear();
});
window.addEventListener('offline', function () {
  toastLoad('Network Error')
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js